import styled from 'styled-components';

const StyledConfirmReservationOutlineAction = styled.button`
  border-radius: 8px;
  background: none;
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 10px 40px;
  width: 100%;
  font-weight: 500;
`;

const StyledConfirmReservationFilledAction = styled.button`
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.primary};
  padding: 10px 40px;
  width: 100%;
  font-weight: 500;
`;

export { StyledConfirmReservationOutlineAction, StyledConfirmReservationFilledAction };
